import { create } from 'zustand'

import type { Detail, Order, StandardTimesKeys } from '@/api/orders/orders-types'
import type { StickerLabel } from '@/components/stickers/stickers-popup'

interface DetailSticker {
  detail: Detail
  inven?: StandardTimesKeys
  labels: StickerLabel[]
}

interface OrderSticker {
  order: Order
  labels: StickerLabel[]
  /** Shipping label variant: same layout, with skid line and QR `&skid=` when set. */
  skidId?: number
  skidLabel?: string
  /** Position of this skid within the order's shipping units (1-based). */
  skidIndex?: number
  /** Total shipping units on the order. */
  skidTotal?: number
  /** `48 x 120` in inches — printed under the skid line when known. */
  skidSize?: string | null
  /** Tally of bundle weights on the skid, in lb. */
  skidWeight?: number | null
  /** When set, print one sticker per skid ("1 of N", "2 of N", …). Overrides single-sticker inputs. */
  skids?: { id: number; label: string; size?: string | null; weight?: number | null }[]
}

/** Standalone shipping-unit sticker (MOS/Outside Rack — no order context). */
interface SkidSticker {
  skidId: number
  skidLabel: string
  skidType: 'SKI' | 'LHB' | 'MOS' | 'OUT'
}

interface PrintStickers {
  printDetail: DetailSticker | null
  setPrintDetail: (detail: DetailSticker | null) => void
  printOrder: OrderSticker | null
  setPrintOrder: (order: OrderSticker | null) => void
  printSkid: SkidSticker | null
  setPrintSkid: (skid: SkidSticker | null) => void
}

export const usePrintStickers = create<PrintStickers>()((set) => ({
  printDetail: null,
  setPrintDetail: (printDetail) => set({ printDetail }),
  printOrder: null,
  setPrintOrder: (printOrder) => set({ printOrder }),
  printSkid: null,
  setPrintSkid: (printSkid) => set({ printSkid })
}))
